import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faUser } from '@fortawesome/pro-solid-svg-icons';
import pluralize from 'pluralize';

export function EmptyState({ contactLabel }) {
  return (
    <div className="empty h-100 w-100">
      <div className="empty-media gap-1 d-flex">
        <FontAwesomeIcon icon={faUser} />
        <FontAwesomeIcon icon={faBriefcase} />
      </div>

      <div className="empty-content">
        <div className="empty-title">No {pluralize(contactLabel)} have been added.</div>
      </div>
    </div>
  );
}

EmptyState.propTypes = {
  contactLabel: PropTypes.string.isRequired,
};

EmptyState.defaultProps = {
  contactLabel: 'contacts',
};

export default EmptyState;
